import { D } from '@wave/shared';

/** Контент поповера KPI-подсказки: объяснение + арифметика (null = без формулы). */
export interface KpiHintContent {
  explain: string;
  math: string | null;
}

/** Юникод-минус для знака в формулах — как в остальном UI балансов. */
function signed(v: string, fmt: (v: string) => string): string {
  return `${D(v).gte(0) ? '+' : '−'}${fmt(D(v).abs().toString())}`;
}

/**
 * Тексты подсказок KPI-карточек /balances. fmt — форматтер сумм со страницы
 * (formatUsdtNum): числа в формулах обязаны совпадать с карточками 1-в-1.
 */
export function buildKpiHints(
  kpi: { count: number; pos: string; neg: string; net: string; wallets: string; position: string },
  fmt: (v: string) => string,
): Record<'count' | 'pos' | 'neg' | 'net' | 'wallets' | 'position', KpiHintContent> {
  const pos = fmt(kpi.pos);
  const negAbs = fmt(D(kpi.neg).abs().toString());
  const wallets = fmt(kpi.wallets);
  return {
    count: {
      explain:
        'Число чатов с ненулевым балансом. TRON-кошельки не считаются — это наши активы, а не обязательства.',
      math: null,
    },
    pos: {
      explain:
        'Наши обязательства перед чатами: сумма положительных нетто-остатков (плюс в чате = мы должны клиенту), в USDT по текущим курсам.',
      math: `Σ положительных нетто чатов = ${pos}`,
    },
    neg: {
      explain:
        'Долги чатов нам: сумма отрицательных нетто-остатков, показана по модулю (минус в чате = клиент должен нам, поэтому зелёный).',
      math: `Σ |отрицательных нетто| = ${negAbs}`,
    },
    net: {
      explain:
        'Нетто всех обязательств: «Мы должны» − «Нам должны». Плюс (красный) — в сумме мы должны чатам; минус (зелёный) — в сумме должны нам.',
      math: `${pos} − ${negAbs} = ${signed(kpi.net, fmt)}`,
    },
    wallets: {
      explain:
        'USDT на наших TRON-адресах (опрос TronScan). Это активы: в «Мы/Нам должны» и «Чистый остаток» не входят.',
      math: `Σ балансов кошельков = ${wallets}`,
    },
    position: {
      explain:
        'Сколько реально нашего: если прямо сейчас рассчитаться со всеми чатами, столько останется на кошельках. Плюс — активы покрывают обязательства.',
      math: `На кошельках − Чистый остаток: ${wallets} − (${signed(kpi.net, fmt)}) = ${signed(kpi.position, fmt)}`,
    },
  };
}
